// Preferências do quadro POR USUÁRIO (PDF Fase 02 — Viz #3 e #4):
// ordem das colunas (drag) e cor de cada coluna, guardadas no localStorage do
// próprio usuário. Não afeta os outros — é uma camada visual pessoal por cima
// das colunas globais (ColunaKanban).

export interface ColunaPrefs {
  /** Chaves das colunas na ordem preferida do usuário. Vazio = ordem padrão. */
  ordem: string[];
  /** Override de cor por chave de coluna (hex). Ausente = cor padrão da coluna. */
  cores: Record<string, string>;
}

function chaveStorage(userId?: string) {
  return `kanban_colprefs_${userId || "anon"}`;
}

export function lerColunaPrefs(userId?: string): ColunaPrefs {
  try {
    const raw = localStorage.getItem(chaveStorage(userId));
    if (raw) {
      const p = JSON.parse(raw);
      return { ordem: Array.isArray(p?.ordem) ? p.ordem : [], cores: p?.cores && typeof p.cores === "object" ? p.cores : {} };
    }
  } catch { /* ignora */ }
  return { ordem: [], cores: {} };
}

export function salvarColunaPrefs(userId: string | undefined, p: ColunaPrefs) {
  try {
    localStorage.setItem(chaveStorage(userId), JSON.stringify(p));
  } catch { /* ignora */ }
}

/**
 * Aplica as preferências do usuário sobre as colunas globais: reordena conforme
 * `ordem` (colunas novas não listadas vão pro fim, na ordem original) e sobrepõe
 * a cor quando há override.
 */
export function aplicarPrefs<T extends { id: string; cor?: string | null }>(colunas: T[], prefs: ColunaPrefs): T[] {
  const porId = new Map(colunas.map((c) => [c.id, c]));
  const ordenadas: T[] = [];
  for (const chave of prefs.ordem) {
    const c = porId.get(chave);
    if (c) { ordenadas.push(c); porId.delete(chave); }
  }
  // Restantes (não citados nas prefs) mantêm a ordem original.
  for (const c of colunas) if (porId.has(c.id)) ordenadas.push(c);
  return ordenadas.map((c) => (prefs.cores[c.id] ? { ...c, cor: prefs.cores[c.id] } : c));
}
